import React, { useState, useEffect } from 'react';
import styled from "styled-components";

const NotePage = ({ data = "", onSubmit }) => {
  const [note, setNote] = useState(data);

  useEffect(() => {
    setNote(data);
  }, [data]);

  const handleNoteSubmit = () => {
    onSubmit(note);
  };

  return (
    <NoteContainer>
      <Title>Quick Notes</Title>
      <StyledTextArea
        placeholder="..."
        value={note}
        onChange={(e) => setNote(e.target.value)}
        onBlur={handleNoteSubmit}
      />
    </NoteContainer>
  );
};

const NoteContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    max-width: 900px;
    margin: 0px auto;
    background: linear-gradient(145deg, #f0f0f0, #c8c8c8);
    border-radius: 15px;
    box-shadow: 12px 12px 24px rgba(0, 0, 0, 0.2), -8px -8px 16px rgba(255, 255, 255, 0.8);

    [data-auth-theme="night"] & {
        background: var(--app-surface, #2b2b2b);
        color: var(--app-surface-text, #eee);
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.24);
    }
`;

const Title = styled.h2`
    color: #444;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 20px;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);

    [data-auth-theme="night"] & {
        color: var(--app-text, #eee);
        text-shadow: none;
    }
`;

const StyledTextArea = styled.textarea`
    width: 100%;
    height: 600px;
    padding: 20px;
    border: none;
    border-radius: 12px;
    resize: vertical;
    font-size: 1rem;
    color: #333;
    background-color: #f9f9f9;
    box-shadow: inset 5px 5px 10px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease, border-color 0.3s ease;
    
    &:focus {
        outline: none;
        border: 1px solid #0077ff;
        box-shadow: 0 0 10px rgba(0, 119, 255, 0.5), inset 2px 2px 5px rgba(0, 0, 0, 0.1);
    }

    &::placeholder {
        color: #bbb;
        font-style: italic;
    }
    
    [data-auth-theme="night"] & {
        background-color: var(--app-input-bg, #2b2b2b);
        color: var(--app-input-text, #eee);
        border: 1px solid var(--app-border, #555);
        box-shadow: inset 5px 5px 10px rgba(0, 0, 0, 0.18);

        &:focus {
            border-color: var(--app-input-text, #eee);
            box-shadow: 0 0 0 2px var(--app-border, #555), inset 2px 2px 5px rgba(0, 0, 0, 0.18);
        }

        &::placeholder {
            color: var(--app-muted-text, #bebebe);
        }
    }

    @media (max-width: 400px) {
      height: 370px;
    }
`;

export default NotePage;
